// extracted by mini-css-extract-plugin
export default {"columns":"Dashboard-columns-ba863bef87da67c002b059aeb767d53b"};